var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select-tree',{attrs:{"data":_vm.bankLevelList,"props":_vm.treeProps,"disabled":_vm.disabled,"default-expand-all":true,"check-strictly":true,"placeholder":"默认"},on:{"change":_vm.selectOne},model:{value:(_vm.levelId),callback:function ($$v) {_vm.levelId=$$v},expression:"levelId"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f1a4b4e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bank/bank-level-select.vue
// module id = null
// module chunks = 